export interface DownloadAnimalExportDocumentQueryResult {
  fileName: string;
  content: string;
}

export interface FarmDocumentViewModel {
  fileName: string;
  farmId: string;
  type: number;
  id: string;
  createdBy: string;
}

export enum ExportFormat {
  Excel = 0,
  ExcelSplitWorkSheet = 1,
  Json = 2
}
